import Vue from "vue";
import Vuex from "vuex";
import Auth from "@/classes/Auth";
import { ProjectReader } from "@/classes/Project/ProjectReader";
import { TimerReader } from "@/classes/Timer/TimerReader";
import { RecordReader } from "../classes/Record/RecordReader";
import { RecordCacheReader } from "../classes/RecordCache/RecordCacheReader";
import { DialogController } from "../classes/DialogController";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  state: {
    user: undefined,
    auth: new Auth(),
    projectReader: undefined,
    timerReader: undefined,
    recordCacheReader: undefined,
    recordReader: undefined,
    projectDialogController: new DialogController()
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    buildReaders(state) {
      const userId = state.user.uid;
      state.projectReader = new ProjectReader({ userId });
      state.timerReader = new TimerReader({ userId });
      state.recordCacheReader = new RecordCacheReader({ userId });
      state.projectReader.start();
      state.timerReader.start();
      state.recordCacheReader.start();

      state.recordReader = new RecordReader({ userId: state.user.uid }, this);
    },
    clearUser(state) {
      state.user = undefined;
    },
    removeReaders(state) {
      if (state.projectReader) state.projectReader = undefined;
      if (state.timerReader) state.timerReader = undefined;
      if (state.recordCacheReader) state.recordCacheReader = undefined;
    }
  },
  actions: {
    addRecord({ state }, record) {
      let p = state.projectReader.getByProjectId(record.projectId);
      p.addRecord(record);
      let recordCache = state.recordCacheReader.getByProjectId(
        record.projectId
      );
      recordCache.addRecord(record);
    },
    removeRecord({ state }, record) {
      let p = state.projectReader.getByProjectId(record.projectId);
      p.removeRecord(record);

      let recordCache = state.recordCacheReader.getByProjectId(
        record.projectId
      );
      recordCache.removeRecord(record);
    },
    initAuth({ state, commit }) {
      state.auth.initAuth(user => {
        commit("setUser", user);
        if (user != null) commit("buildReaders");
        else {
          commit("removeReaders");
        }
      });
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    auth(state) {
      return state.auth;
    }
  }
});
